import React from 'react';
import './ChallengeListRow.css';

function ChallengeListRow({ challenge, currentUserId, onJoin, onViewDetails, onEdit, onCancel, getTimeRemaining, formatEndTime }) {
  const handleJoinClick = (e) => {
    e.stopPropagation();
    onJoin(challenge.id);
  };

  const handleViewClick = (e) => {
    e.stopPropagation();
    onViewDetails(challenge.id);
  };

  const handleEditClick = (e) => {
    e.stopPropagation();
    onEdit(challenge.id);
  };

  const handleCancelClick = (e) => {
    e.stopPropagation();
    onCancel(challenge.id);
  };

  const isOwner = challenge.created_by_user_id === currentUserId;
  const canEditOrCancel = isOwner && challenge.status === 'accepting';
  const userIsParticipant = challenge.user_is_participant > 0;

  const getStatusDisplay = () => {
    switch (challenge.status) {
      case 'accepting':
        const timeRemaining = getTimeRemaining ? getTimeRemaining(challenge.acceptance_deadline) : 'Open';
        return (
          <div className="status-accepting">
            {timeRemaining}
          </div>
        );
      case 'active':
        return <div className="status-active">Active</div>;
      case 'completed':
        return <div className="status-completed">Completed</div>;
      case 'cancelled':
        return <div className="status-cancelled">Cancelled</div>;
      default:
        return null;
    }
  };

  const getDateDisplay = () => {
    if (challenge.status === 'accepting' && challenge.acceptance_deadline) {
      return `Join by: ${formatEndTime ? formatEndTime(challenge.acceptance_deadline) : challenge.acceptance_deadline}`;
    }
    if (challenge.status === 'active' && challenge.end_time) {
      return `Ends: ${formatEndTime ? formatEndTime(challenge.end_time) : challenge.end_time}`;
    }
    if (challenge.status === 'completed' && challenge.completed_at) {
      return `Completed: ${formatEndTime ? formatEndTime(challenge.completed_at) : challenge.completed_at}`;
    }
    return '';
  };

  return (
    <div 
      className={`challenge-list-row ${challenge.status}`}
      onClick={() => onViewDetails(challenge.id)}
    >
      {/* Row 1: Title, Description, Status */}
      <div className="list-row-top">
        <div className="row-title-section">
          <h4 className="row-title-text">{challenge.title}</h4>
          {challenge.description && (
            <p className="row-description">{challenge.description}</p>
          )}
        </div>
        <div className="row-status-section">
          {getStatusDisplay()}
        </div>
      </div>
      
      {/* Row 2: Metadata and Actions */}
      <div className="list-row-bottom">
        <div className="row-meta-section">
          <div className="meta-item creator">
            <img 
              src={`/assets/Profile/${challenge.creator_avatar}`} 
              alt={challenge.creator_first_name}
              className="creator-avatar"
            />
            <span className="creator-name">
              {challenge.creator_first_name} {challenge.creator_last_name}
            </span>
          </div>
          <div className="meta-item participants">
            <span className="meta-icon">👥</span>
            <span className="meta-value">{challenge.participant_count}</span>
          </div>
          <div className="meta-item date">
            <span className="meta-value">{getDateDisplay()}</span>
          </div>
        </div>
        
        <div className="row-actions-section" onClick={(e) => e.stopPropagation()}>
          {canEditOrCancel && (
            <>
              <button className="action-btn edit-btn" onClick={handleEditClick} title="Edit">
                ✏️
              </button>
              <button className="action-btn cancel-btn" onClick={handleCancelClick} title="Cancel">
                🗑️
              </button>
            </>
          )}
          
          {challenge.status === 'accepting' && !userIsParticipant && (
            <button className="action-btn join-btn" onClick={handleJoinClick}>
              Join Challenge
            </button>
          )}
          
          {userIsParticipant && (
            <span className="joined-badge">✓ You're In</span>
          )}
          
          <button className="action-btn view-btn" onClick={handleViewClick}>
            View Details →
          </button>
        </div>
      </div>
    </div>
  );
}

export default ChallengeListRow;
